import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import {
  getItemHistory,
  ITEM_HISTORY_STORAGE_KEY,
  ITEM_HISTORY_STORAGE_QUERY_KEY,
  type ItemHistoryItem,
} from './utils';

const useItemHistory = (): ItemHistoryItem[] => {
  const queryClient = useQueryClient();
  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === ITEM_HISTORY_STORAGE_KEY)
        queryClient.invalidateQueries({
          queryKey: ITEM_HISTORY_STORAGE_QUERY_KEY,
        });
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [queryClient]);

  const { data } = useQuery<ItemHistoryItem[]>({
    queryKey: ITEM_HISTORY_STORAGE_QUERY_KEY,
    queryFn: getItemHistory,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  return data || [];
};

export default useItemHistory;
